import React from "react";

// Files Import
import { content } from "../../../data";
import { NavLink } from "react-router-dom";
import Copyrights from "../../Copyrights/Copyrights";
import StyledSmText from "../../../common/components/styledSmText/StyledSmText";

const ProfileFooter = () => {
  return (
    <div className="w-full flex justify-center items-center pb-2 max-w-[1920px] mx-auto ">
      <div className="w-[80%] flex flex-col gap-3 pt-[4%]">
        <div>
          <hr className="w-full h-[1px] bg-white opacity-30" />
        </div>
        <div className="flex flex-col md:flex-row items-center md:items-start md:justify-between gap-2">
          <div>
            <Copyrights />
          </div>
          {/* Footer Links */}
          <div className="flex gap-7 items-center">
            {content.profileFooter.map((item, index) => (
              <NavLink
                key={index}
                to={item.link}
                className="text-light-gray hover:underline text-center"
              >
                <StyledSmText>{item.title}</StyledSmText>
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileFooter;
